module.exports = __webpack_public_path__ + "static/img/pexels-pixabay-417430.2c63bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CheapFlights/pexels-pixabay-417430.png
// module id = p/zZ
// module chunks = 1